
  <head>
  	<title>RA REGISTER</title>
    <meta charset="utf-8">
    <meta name="viewport" content="width=device-width, initial-scale=1, shrink-to-fit=no">

	<link href="https://fonts.googleapis.com/css?family=Lato:300,400,700&display=swap" rel="stylesheet">

	<link rel="stylesheet" href="https://stackpath.bootstrapcdn.com/font-awesome/4.7.0/css/font-awesome.min.css">
  <link rel="stylesheet" href="../../../../assets/css/style.css">
  <link
  rel="stylesheet"
  href="https://cdnjs.cloudflare.com/ajax/libs/intl-tel-input/17.0.8/css/intlTelInput.css"
   />
  <script src="https://cdnjs.cloudflare.com/ajax/libs/intl-tel-input/17.0.8/js/intlTelInput.min.js"></script>

	</head>
<div>

	<section class="ftco-section">
		<div class="container">
			<div class="row justify-content-center">
			</div>
			<div class="row justify-content-center">
				<div class="col-md-6 col-lg-5">
					<div class=" p-4 p-md-5">
						<div *ngIf="errtext !='' && change!=true" class="alert alert-danger" style="text-align:center ; font-weight: normal;">
							<small>
								{{errtext}}
							</small>
						</div>
						<div *ngIf="errtext !=''  &&  change" class="alert alert-success" style="text-align: center;font-weight: normal;">
							<small>
								{{errtext}}
							</small>
						</div>
	   
							<div class=" d-flex align-items-center justify-content-center "> 
		      		
								<img src="/assets/img/whiteicon.png " class = "logo">
					  
								  </div>
								<div class=" d-flex align-items-center justify-content-center "> 
								<div class="hh"  >Robo-Advisor</div>
								
								  </div>
									<!-- Reactive Form start here  -->
				<form class="login-form" [formGroup]="ForgetPasswordForm" (ngSubmit)="ChangePassword()" >
				  <div class="form-group">
						<input type="email" class="form-control rounded-left"  formControlName="email" pattern="[^ @]*@[^ @]*" placeholder="saisissez l'adresse courriel">
						<div *ngIf="email.touched && email.errors?.required" class="invalid-feedback d-block">Adresse courriel est obligatoire</div>
						<div *ngIf="email.touched && email.errors?.email" class="invalid-feedback d-block" >Adresse courriel invalide</div>
				  </div>

	           <div class="form-group">
	            	<button type="submit"  [disabled]="ForgetPasswordForm.invalid" class="btn btn-primary rounded submit p-3 px-5">CHANGER MOT DE PASSE</button>
	            </div>
                <div class="form-group md-d-flex">
                     <div class=" d-flex justify-content-center links" style="margin-top: 110px;">
                        <!-- Vous avez un compte ? <a [routerLink]="['/']" routerLinkActive="router-link-active"  class="ml-2" style="font-weight: bold;">CONNEXION</a> -->
                     </div> 
                 </div>
	          </form>
            <!-- Form End here  -->

	        </div>
			</div>
			</div>

		</div>
	</section>

	<script src="../../../../assets/js/jquery.min.js"></script>
  <script src="../../../../assets/js/popper.js"></script>
  <script src="../../../../assets/js/bootstrap.min.js"></script>
  <script src="../../../../assets/js/main.js"></script>
</div>
